









import {Component, Vue, Prop} from 'vue-property-decorator';

@Component
export default class IconCloseButton extends Vue {
  @Prop({default: ''})
  public text!: string;

  @Prop({default: 0})
  public tabindex!: number;

  @Prop({default: ''})
  public ariaLabel!: string;
}
